export default __webpack_public_path__ + "static/media/elipse_valeur.ae388349.svg";